import React, { Fragment } from 'react';
import {Link} from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { Helmet } from 'react-helmet';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Terms from '../Terms';
import * as Strings from '../../constants';

class Phase extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      isPaneOpen: false,
      selectedTerm: '',
    };
  }

  componentDidMount() {
    Modal.setAppElement(this.el);
  }

  filterPhases = (current=false) => {
    let allPhases = this.props.phases;
    if (current){
      let phase = allPhases.filter(ps =>
        ps[ 'Scenario' ] === this.props.scenario & ps[ 'Nr' ] === this.props.phase
      );
      return phase;
    }
    else{
      let phases = allPhases.filter(ps => ps[ 'Scenario' ] === this.props.scenario);
      return phases;
    }
  }

  filterUsecases = () => {
    let allUsecases = this.props.usecases;
    let usecases = allUsecases.filter(us =>
        us[ 'Scenario' ] === this.props.scenario & us[ 'Phase Nr' ] === this.props.phase
      );
    return usecases;
  }

  buildClass = (p) => {
    let classname = "phase";
    if (this.props.phase === p.Nr){
      classname = "phase active phase-" + p.Nr;
    }
    else{
      classname = "phase light phase-" + p.Nr;
    }
    return classname;
  }

  render() {

    const phases = this.filterPhases(false);
    const usecases = this.filterUsecases();
    const currentPhase = this.filterPhases(true);

    return(
      <div className={"phaseWrapper " + this.props.scenario} ref={ref => this.el = ref}>
         <div className="phases">
          <Row>
            {
              phases.map(obj => {
                if (obj.Nr===this.props.phase){
                  return(
                    <Col key={obj.Nr}>


      <Helmet>
        <title>{obj.Title + " · " + Strings.Meta_PageTitle}</title>
      </Helmet>


                      <div className={this.buildClass(obj)} >
                        <p className="tag scenarioBd">Phase {obj.Nr}</p>
                        <h1 className="title">{obj.Title}</h1>
                      </div>
                    </Col>
                  )
                }
                else{
                  return(
                    <Col key={obj.Nr}>
                      <Link to={`/s/${this.props.scenario}/phase-${obj.Nr}`}>
                        <div className={this.buildClass(obj)} >
                          <p className="tag">Phase {obj.Nr}</p>
                          <p className="title">{obj.Title}</p>
                        </div>
                      </Link>
                    </Col>
                  )
                }
              })
            }
          </Row>
        </div>

        <div className="phaseDetail">
          <Row>
            {
              currentPhase.map(obj => {
                return (
                  <Fragment key={obj.Nr}>
                    <Col md={3} className="icon">
                      <img
                        src={`/img/${this.props.scenario}-phase-${this.props.phase}.png`}
                        alt="Phase icon"
                        className="phaseIcon"
                      />
                    </Col>
                    <Col md={4}>
                      <h3>{Strings.PhaseDescription}</h3>
                       <div className="description">
                        <ReactMarkdown source={obj.Description} />
                      </div>
                    </Col>
                    <Col md={5} className="meta">
                      <h3>{Strings.ConventionalFormats}</h3>
                      <div className="inclusionFormats">
                        <ReactMarkdown source={obj['Conventional inclusion formats']} />
                      </div>
                      {/*
                      <h3>Strategic purpose of inclusion</h3>
                      <div className="strategicPurpose">
                        {
                          obj['Strategic purpose of inclusion'].split('+').map((item, i) =>
                            <button
                              key={i}
                              className='clickableTag'
                              onClick={() => this.setState({
                                isPaneOpen: true,
                                selectedTerm: item
                              })}
                            >
                              {item}
                            </button>
                          )
                        }
                      </div>
                      */}
                    </Col>
                  </Fragment>
                )
              })
            }
          </Row>
        </div>

        <div className="useCases">
          <Row>
            <Col>
              <p className="noCases scenarioCol">
                {Strings.ExploreUseCases_bfrNo} {usecases.length}  {Strings.ExploreUseCases_aftrNo}
              </p>
            </Col>
          </Row>
          {
            usecases.map((obj, index) => {
              return (
                <Row key={obj.Title}>
                  <Col>
                    <div className="useCase scenarioBg">
                      <Row>
                        <Col md={6} className="left">
                          <p className="tag">Use Case {index + 1}</p>
                          <h2 className="title">{obj.Title}</h2>
                          <div className="description">
                            <ReactMarkdown source={obj.Description} />
                          </div>
                          <h3>{Strings.ContextualVariations}</h3>
                          <div className="contextualVariations">
                            <ReactMarkdown source={obj['Contextual variations']} />
                          </div>
                          <h3>{Strings.Risks}</h3>
                          <div className="risks">
                            <ReactMarkdown source={obj['Risks and consequences']} />
                          </div>
                        </Col>
                        <Col md={{ span: 5, offset: 1 }} className="right">
                          <h3>{Strings.StrategicPurpose}</h3>
                          <div className="strategicPurpose">
                            {
                              obj['Strategic purpose'].split('+').map((item, i) =>
                                <button
                                  key={i}
                                  className='clickableTag'
                                  onClick={() => this.setState({
                                    isPaneOpen: true,
                                    selectedTerm: item
                                  })}
                                >
                                  {item}
                                </button>
                              )
                            }
                          </div>
                          <h3>{Strings.Functions}</h3>
                          <div className="function">
                            {
                              obj['Function'].split('+').map((item, i) =>
                                <button
                                  key={i}
                                  className='clickableTag'
                                  onClick={() => this.setState({
                                    isPaneOpen: true,
                                    selectedTerm: item
                                  })}
                                >
                                  {item}
                                </button>
                              )
                            }
                          </div>
                          <h3>{Strings.Outputs}</h3>
                          <div className="outputs">
                            {
                              obj['Outputs'].split('+').map((item, i) =>
                                <button
                                  key={i}
                                  className='clickableTag'
                                  onClick={() => this.setState({
                                    isPaneOpen: true,
                                    selectedTerm: item
                                  })}
                                >
                                  {item}
                                </button>
                              )
                            }
                          </div>
                          <h3>{Strings.TechnologiesUsed}</h3>
                          <div className="technologies">
                            <p>{obj['Technologies used']}</p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              )
            })
          }
        </div>

        <div className="phases repeated">
          <Row>
            <Col>
              <h3 className="exploreScenarios">{Strings.ProceedToOtherPhase}</h3>
            </Col>
          </Row>
          <Row>
            {
              phases.map(obj => {
                if (obj.Nr===this.props.phase){
                  return(
                    <Col key={obj.Nr}>
                      <div className={this.buildClass(obj)} >
                        <p className="tag scenarioBd">Phase {obj.Nr}</p>
                        <h1 className="title">{obj.Title}</h1>
                      </div>
                    </Col>
                  )
                }
                else{
                  return(
                    <Col key={obj.Nr}>
                      <Link to={`/s/${this.props.scenario}/phase-${obj.Nr}`}>
                        <div className={this.buildClass(obj)} >
                          <p className="tag">Phase {obj.Nr}</p>
                          <p className="title">{obj.Title}</p>
                        </div>
                      </Link>
                    </Col>
                  )
                }
              })
            }
          </Row>
        </div>

        <SlidingPane
          className={this.props.scenario}
          overlayClassName='terms-overlay-pane'
          isOpen={this.state.isPaneOpen}
          title={Strings.DrawerTitle}
          subtitle={Strings.DrawerSubtitle}
          width='50vw'
          onRequestClose={ () => {
              // triggered on "<" on left top click or on outside click
              this.setState({ isPaneOpen: false });
          } }>
          <Terms selectedTerm={this.state.selectedTerm}/>
        </SlidingPane>
      </div>
    )
  }
}
export default Phase;



// WEBPACK FOOTER //
// ./src/components/Phase/phase.js